var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSourceAsset = function SvgSourceAsset(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1514_962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8124 2.1875C17.3647 2.1875 17.8124 2.63522 17.8124 3.1875L17.8134 11.4551C17.3555 10.9571 16.7867 10.5625 16.1462 10.3106L16.1458 8.1875H12.8749L12.8748 10.3024C12.4169 10.4798 11.9953 10.73 11.6241 11.0388L11.6249 8.1875H8.37492V11.5417L11.1087 11.542C10.787 11.9106 10.5243 12.3321 10.3356 12.7917L8.37492 12.7917V16.1458L10.3106 16.1462C10.5588 16.7773 10.9454 17.3387 11.4331 17.7931L3.20825 17.7917C2.65597 17.7917 2.20825 17.344 2.20825 16.7917V3.1875C2.20825 2.63522 2.65597 2.1875 3.20825 2.1875H16.8124ZM7.12492 12.7917H3.85409V16.1458H7.12492V12.7917ZM7.12492 8.1875H3.85409V11.5417H7.12492V8.1875ZM16.1458 3.85417H3.85409V6.9375H16.1458V3.85417Z",
    fill: "#171615"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7197 13.5H12.5303V12H17.2803V16.75H15.7803V14.5608L13.0607 17.2804L12 16.2197L14.7197 13.5Z",
    fill: "#171615"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1514_962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSourceAsset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/source_asset.5e7dd17788ede963d1b88f0d6b0a3e22.svg";